import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
import { useEffect, forwardRef, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import * as React from "react";

import { factory } from "../../api/apiFactory";
const atsApi = factory.get("ats");

export const SelectAts = forwardRef((props, ref) => {
  const [options, setOptions] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  //TODO: add client_id to props
  //TODO: add locall_ats to props
  //TODO: add onChange to props
  //TODO: make it list of ats or single ats

  const fetchAts = (search = "") => {
    setLoading(true);
    const params = {
      skip: 0,
      take: 40,
      // is_repeater_or_sub: props.is_repeater_or_sub || false,
    };
    if (props.client_id) {
      params.client_id = props.client_id;
    } else {
      params.search = search;
    }
    atsApi.list(params).then((res) => {
      setOptions(res.data.data);
      setLoading(false);
    });
  };

  useEffect(() => {
    if (props.client_id) {
      fetchAts();
    }
  }, [props.client_id]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!props.client_id) {
      const timeout = setTimeout(() => {
        fetchAts(search);
      }, 500);
      return () => clearTimeout(timeout);
    }

    // else {
    //   if (props.locall_ats) {
    //     setOptions(props.locall_ats);
    //   } else {
    //     fetchAts();
    //   }
    // }
  }, [search, props.client_id]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Autocomplete
      {...props}
      ref={ref}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      renderOption={(props, option) => {
        return (
          <li {...props} key={option.id}>
            {option.name}
          </li>
        );
      }}
      isOptionEqualToValue={(option, value) => option?.id === value?.id || ""}
      getOptionLabel={(option) => `${option.name}`}
      options={options}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          helperText={props.helpertext}
          label={props.label || "Towers"}
          size="small"
          onChange={(e, value) => {
            setSearch(e.target.value);
          }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
});
